module.exports = __webpack_public_path__ + "img/79228c2.jpg";